<div
  #selectedContainer
  class="p-flight-container"
  [ngClass]="{
    'p-flight-container--selected': this.isSelected || this.isTmpSelected,
    'p-flight-container--applied': this.selectTSFFInfo?.isPromotionAppliedIcon,
    'p-flight-container--cancelled': this.lowestPriceTsffInfo && !this.lowestPriceTsffInfo.isAvailable
  }"
>
  <div class="p-flight-container__tag" *ngIf="this.isSelected || this.isTmpSelected">
    <div class="p-flight-container__tag-item p-flight-container__tag-item--selected">
      <em [innerHTML]="'label.currentFare1' | staticMsg"></em
      ><span class="u-visually-hidden">{{ 'label.currentFare2' | staticMsg }}</span>
    </div>
  </div>
  <div class="p-flight-container__inner">
    <!-- フライトサマリ部 -->
    <!-- フライトの(最新)出発・到着地、出発到着時刻、所要時間、乗継回数を表示する画面部品 -->
    <asw-flight-plan
      [id]="this.tealiumSummaryId"
      class="p-flight-container__inner-item1"
      [isSelected]="this.isSelected"
      [flightSummary]="this.flightSummary"
      [boundIndex]="this.boundIndex"
      [tsListIndex]="this.tsListIndex"
      [isOpenFlightDetail]="this.isOpenFlightDetail"
      (openFlightDetailModalEvent)="this.clickFlightDetailLink(this.boundIndex, this.tsListIndex)"
      (changeOpenFlightDetailEvent)="this.changeOpenFlightDetail(this.boundIndex, this.tsListIndex)"
    >
    </asw-flight-plan>

    <!-- FF情報部 -->
    <div [id]="this.tealiumFfId" class="p-flight-container__inner-item2">
      <div class="p-flight-container__fare" *ngIf="this.isSelected; else unSelectTSFFInfo">
        <div class="p-flight-container__fare-item">
          <!-- プロモーション適用有無のマーク -->
          <ng-container *ngIf="this.selectTSFFInfo?.isPromotionAppliedIcon">
            <div class="p-flight-container__fare-applied">
              <span class="c-promotion-applied">
                <img
                  class="c-promotion-applied__img"
                  src="assets/images/icon_promotion_applied_20.svg"
                  width="20"
                  height="20"
                  alt="{{ 'reader.promotionIconDisplay' | staticMsg }}"
                />
              </span>
            </div>
          </ng-container>
          <!-- 最低価格の場合ラベルの追加 -->
          <ng-container *ngIf="this.selectTSFFInfo?.lowestPrice">
            <div class="p-flight-container__fare-icon">
              <span class="c-tag-lowest-price" [innerHTML]="'label.lowestprice1' | staticMsg"></span>
            </div>
          </ng-container>
          <!-- 金額 -->
          <p
            class="p-flight-container__fare-price"
            [innerHTML]="this.numPrice | amountFormat : 'availability.flightContainer_totalPrice'"
          ></p>
          <ng-container *ngIf="this.selectTSFFInfo?.originalPrice">
            <!-- プロモーション適用前金額 -->
            <p class="p-flight-container__fare-del" [innerHTML]="this.selectTSFFInfo?.originalPrice"></p>
          </ng-container>
          <!-- FF名称 -->
          <p class="p-flight-container__fare-text">{{ this.selectTSFFInfo?.fareFamilyName }}</p>
        </div>
        <div class="p-flight-container__fare-item">
          <!-- 選択時のFF選択表示ボタン -->
          <ng-container *ngIf="this.isSelected">
            <button
              id="flight-summary-and-fare-family-change-fare-btn-select"
              class="c-btn-tertiary c-btn-tertiary--s"
              (throttleClick$)="this.clickSelectButton(this.boundIndex, this.tsList!)"
              aswThrottleClick
            >
              <span class="c-btn-tertiary__text" [innerHTML]="'label.changeFare' | staticMsg"></span>
            </button>
          </ng-container>
        </div>
      </div>
      <ng-template #unSelectTSFFInfo>
        <div class="p-flight-container__fare" *ngIf="this.lowestPriceTsffInfo && this.lowestPriceTsffInfo.isAvailable">
          <div class="p-flight-container__fare-item">
            <span class="u-visually-hidden">{{ this.lowestPriceTsffInfo.airportNameListStr }}</span>
            <span class="u-visually-hidden">{{ this.lowestPriceTsffInfo.displayContent }}</span>
            <span class="u-visually-hidden">{{ this.lowestPriceTsffInfo.fareFamilyName }}</span>
            <!-- プロモーション適用有無のマーク -->
            <ng-container *ngIf="this.lowestPriceTsffInfo.isPromotionApplied">
              <div class="p-flight-container__fare-applied">
                <span class="c-promotion-applied">
                  <img
                    class="c-promotion-applied__img"
                    src="assets/images/icon_promotion_applied_20.svg"
                    width="20"
                    height="20"
                    alt="{{ 'reader.promotionIconDisplay' | staticMsg }}"
                  />
                </span>
              </div>
            </ng-container>
            <!-- 最低価格の場合ラベルの追加 -->
            <ng-container *ngIf="this.lowestPriceTsffInfo.isLowestPrice">
              <div class="p-flight-container__fare-icon">
                <span class="c-tag-lowest-price" [innerHTML]="'label.lowestprice1' | staticMsg"></span>
              </div>
            </ng-container>
            <!-- 金額 -->
            <p
              class="p-flight-container__fare-price"
              [innerHTML]="
                this.lowestPriceTsffInfo.price ?? 0 | amountFormat : 'availability.flightContainer_fare.from'
              "
            ></p>
            <ng-container *ngIf="this.lowestPriceTsffInfo.originalPrice">
              <!-- プロモーション適用前金額 -->
              <p class="p-flight-container__fare-del">
                <span class="p-flight-container__fare-del-num"
                  ><del
                    [innerHTML]="
                      this.lowestPriceTsffInfo.originalPrice | amountFormat : 'availability.flightContainer_beforePrice'
                    "
                  ></del
                ></span>
              </p>
            </ng-container>
            <!-- FF名称 -->
            <p class="p-flight-container__fare-text">{{ this.lowestPriceTsffInfo.fareFamilyName }}</p>
          </div>
          <div class="p-flight-container__fare-item">
            <!-- SP・TAB版でのTS別FF情報としてのFF選択表示ボタン -->
            <ng-container *ngIf="this.isTmpSelected">
              <button
                id="flight-summary-and-fare-family-change-fare-btn-tmpSelect"
                class="c-btn-tertiary c-btn-tertiary--s"
                (throttleClick$)="this.clickSelectButton(this.boundIndex, this.tsList!)"
                aswThrottleClick
              >
                <span class="c-btn-tertiary__text" [innerHTML]="'label.changeFare' | staticMsg"></span>
              </button>
            </ng-container>
            <ng-container *ngIf="!this.isTmpSelected">
              <button
                id="flight-summary-and-fare-family-select-radio-btn"
                class="c-btn-primary c-btn-primary--s"
                (throttleClick$)="this.clickSelectButton(this.boundIndex, this.tsList!)"
                aswThrottleClick
              >
                <span class="c-btn-primary__text" [innerHTML]="'label.selectRadio' | staticMsg"></span>
              </button>
            </ng-container>
          </div>
        </div>
      </ng-template>
      <!-- 利用不可の場合 -->
      <div class="p-flight-container__none" *ngIf="this.lowestPriceTsffInfo && !this.lowestPriceTsffInfo.isAvailable">
        <span class="u-visually-hidden">{{ this.lowestPriceTsffInfo.airportNameListStr }}</span>
        <span class="u-visually-hidden">{{ this.lowestPriceTsffInfo.displayContent }}</span>
        <span class="u-visually-hidden">{{ this.lowestPriceTsffInfo.fareFamilyName }}</span>
        <p
          class="p-flight-container__none-text p-flight-container__none-text--dark"
          [innerHTML]="'label.noVacancy1' | staticMsg"
        ></p>
      </div>
    </div>
  </div>
</div>
